<template>
  <v-container fluid>
    <v-row>
      <v-col
        class="d-flex align-center">
        <span
          class="font-weight-bold foreground--text ui-text-lg">
          {{ step === 1
            ? 'Nova configuração de Parâmetro de Fatura'
            : 'Editar Regra de Parâmetro de Fatura'
          }}

        </span>
      </v-col>
      <v-col
        style="max-width: 600px;">
        <InvoiceStepper />
      </v-col>
    </v-row>
    <v-form ref="LevelSelectionStep">
      <LevelSelectionStep />
    </v-form>
    <v-scroll-x-transition>
      <v-form ref="InvoiceRuleDetail">
        <InvoiceRuleDetail
          v-if="step === 2"
          class="my-7"
        />
      </v-form>
    </v-scroll-x-transition>
    <div
      :class="{
        'd-flex flex-row gap-h-20 mt-5': true,
      }">
      <div
        v-if="step === 2 && (isCreatingConfig || isCopyingConfig)"
        class="primary--text d-flex flex-row align-center"
        style="cursor: pointer;"
        @click="goToLevelSelection">
        <div
          class="primary rounded-circle d-flex justify-center align-center mr-2"
          style="height: 40px; width: 40px;">
          <v-icon
            color="muted">
            fas fa-arrow-left
          </v-icon>
        </div>
        Voltar Etapa anterior
      </div>
      <v-spacer />
      <v-btn
        class="action-button-filter"
        color="primary"
        outlined
        @click="startCancelation">
        Cancelar
      </v-btn>
      <v-btn
        v-if="step === 1"
        class="action-button-filter"
        color="primary"
        @click="startSelectionStepValidation">
        Avançar
      </v-btn>
      <v-btn
        v-if="step === 2 && isCreatingConfig"
        class="action-button-filter"
        color="primary"
        @click="saveConfig">
        Salvar Regra
      </v-btn>
      <v-btn
        v-if="step === 2 && isCopyingConfig"
        class="action-button-filter"
        color="primary"
        @click="copyConfig">
        Salvar Regra
      </v-btn>
      <v-btn
        v-if="step === 2 && isUpdatingConfig"
        class="action-button-filter"
        color="primary"
        @click="updateConfig">
        Atualizar Regra
      </v-btn>
    </div>

    <RuleUnlinkModal title="Status de Desvinculação" label="desvincular" :show="showRuleUnlinkModal" @confirm="confirmUnlink($event)" />
    <RuleStatusInactiveModal label="inativar" :show="showRuleStatusInactiveModal" @confirm="confirmUpdateStatusToInactive($event)" />
    <RuleStatusActiveModal label="ativar" :show="showRuleStatusActiveModal" @confirm="confirmUpdateStatusToActive($event)" />
    <RuleLinkModal title="Status de Vinculação" label="vincular" :show="showRuleLinkModal" @confirm="confirmLink($event)" />
    <RuleConfigUnlinkSuccessModal title="Desvinculação Concluída" label="desvinculada" :show="showRuleUnlinkSuccessModal" />
    <RuleConfigLinkSuccessModal title="Vinculação Concluída" label="vinculada" :show="showRuleLinkSuccessModal" />
    <RuleUpdatedSuccessfullyModal :show="showRuleUpdatedSuccessfullyModal" @confirm="refreshForm" />
    <RuleStatusInactiveUpdatedModal label="inativada" :show="showRuleStatusInactiveUpdatedModal" />
    <RuleStatusActiveUpdatedModal label="ativada" :show="showRuleStatusActiveUpdatedModal" />
    <CancelConfirmModal :show="showCancelConfirmModal" @confirm="cancel($event)" />
    <ConfirmAlterationRuleModal :show="showConfirmAlterationRuleModal" />
    <ConflictingRuleFoundModal :show="showConflictingRuleFoundModal" />
    <CreateRuleInactiveModal :show="showCreateRuleInactiveModal" />
    <RelatedRulesModal :show="showRelatedRulesModal" />
    <RuleCreatedModal :show="showRuleCreatedModal" />
    <ConfirmInfoModal :show="showConfirmInfoModal" />

    <SnackbarCustomize ref="InvoiceParameterFormSnackbar" />
    <FullScreenLoader v-if="loadingForm" />
  </v-container>
</template>

<script>
import RuleUpdatedSuccessfullyModal from '@/components/InvoiceParameters/modals/RuleUpdatedSuccessfullyModal.vue';
import RuleStatusConfirmationModal from '@/components/InvoiceParameters/modals/RuleStatusConfirmationModal.vue';
import ConfirmAlterationRuleModal from '@/components/InvoiceParameters/modals/ConfirmAlterationRuleModal.vue';
import ConflictingRuleFoundModal from '@/components/InvoiceParameters/modals/ConflictingRuleFoundModal.vue';
import CreateRuleInactiveModal from '@/components/InvoiceParameters/modals/CreateRuleInactiveModal.vue';
import RuleStatusUpdatedModal from '@/components/InvoiceParameters/modals/RuleStatusUpdatedModal.vue';
import RuleLinkSuccessModal from '@/components/InvoiceParameters/modals/RuleLinkSuccessModal.vue';
import InvoiceParametersMixin from '@/shared/mixins/invoiceParameters/InvoiceParametersMixin';
import CancelConfirmModal from '@/components/InvoiceParameters/modals/CancelConfirmModal.vue';
import RelatedRulesModal from '@/components/InvoiceParameters/modals/RelatedRulesModal.vue';
import ConfirmInfoModal from '@/components/InvoiceParameters/modals/ConfirmInfoModal.vue';
import RuleCreatedModal from '@/components/InvoiceParameters/modals/RuleCreatedModal.vue';
import LevelSelectionStep from '@/components/InvoiceParameters/LevelSelectionStep.vue';
import InvoiceRuleDetail from '@/components/InvoiceParameters/InvoiceRuleDetail.vue';
import RuleLinkModal from '@/components/InvoiceParameters/modals/RuleLinkModal.vue';
import FullScreenLoader from '@/components/FullScreenLoader/FullScreenLoader.vue';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import InvoiceStepper from '@/components/InvoiceParameters/InvoiceStepper.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'InvoiceParameterForm',
  components: {
    RuleStatusInactiveModal: RuleStatusConfirmationModal,
    RuleStatusActiveModal: RuleStatusConfirmationModal,
    RuleStatusInactiveUpdatedModal: RuleStatusUpdatedModal,
    RuleStatusActiveUpdatedModal: RuleStatusUpdatedModal,
    RuleUpdatedSuccessfullyModal,
    ConfirmAlterationRuleModal,
    ConflictingRuleFoundModal,
    CreateRuleInactiveModal,
    CancelConfirmModal,
    LevelSelectionStep,
    RelatedRulesModal,
    SnackbarCustomize,
    InvoiceRuleDetail,
    ConfirmInfoModal,
    RuleCreatedModal,
    FullScreenLoader,
    InvoiceStepper,
    RuleUnlinkModal: RuleLinkModal,
    RuleLinkModal: RuleLinkModal,
    RuleConfigUnlinkSuccessModal: RuleLinkSuccessModal,
    RuleConfigLinkSuccessModal: RuleLinkSuccessModal,
  },
  mixins: [
    InvoiceParametersMixin,
  ],
  watch: {
    showSnackbarCustomize: {
      handler(snackbar) {
        if (snackbar.show === true) {
          this.$refs.InvoiceParameterFormSnackbar.open(
            snackbar.type,
            snackbar.message
          );
        }
      }
    },
  },
  methods: {
    ...mapActions({
      validateConfigsInSelectionStep: 'invoice-parameter/fetchValidationConfigsInLevelSelectionStep',
      updateRuleConfigurations: 'invoice-parameter/updateFormConfig',
      createNewConfigs: 'invoice-parameter/createNewConfigs',
      copyFormConfig: 'invoice-parameter/copyFormConfig',
      getRuleData: 'invoice-parameter/getRuleData',
    }),
    ...mapMutations({
      setShowRuleStatusInactiveUpdatedModal: 'invoice-parameter/setShowRuleStatusInactiveUpdatedModal',
      setShowRuleStatusActiveUpdatedModal: 'invoice-parameter/setShowRuleStatusActiveUpdatedModal',
      setShowRuleUpdatedSuccessfullyModal: 'invoice-parameter/setShowRuleUpdatedSuccessfullyModal',
      setShowRuleStatusInactiveModal: 'invoice-parameter/setShowRuleStatusInactiveModal',
      setShowRuleUnlinkSuccessModal: 'invoice-parameter/setShowRuleUnlinkSuccessModal',
      setShowRuleStatusActiveModal: 'invoice-parameter/setShowRuleStatusActiveModal',
      setShowRuleLinkSuccessModal: 'invoice-parameter/setShowRuleLinkSuccessModal',
      setShowCancelConfirmModal: 'invoice-parameter/setShowCancelConfirmModal',
      setShowRuleUnlinkModal: 'invoice-parameter/setShowRuleUnlinkModal',
      setSessionCurrentForm: 'invoice-parameter/setCurrentSessionForm',
      goToAdvanceRuleDetail: 'invoice-parameter/goToAdvanceRuleDetail',
      setShowRuleLinkModal: 'invoice-parameter/setShowRuleLinkModal',
      setSessionIsCreating: 'invoice-parameter/setSessionIsCreating',
      setSessionIsUpdating: 'invoice-parameter/setSessionIsUpdating',
      setSessionIsCopying: 'invoice-parameter/setSessionIsCopying',
      goToLevelSelection: 'invoice-parameter/goToLevelSelection',
      setSessionForm: 'invoice-parameter/setSessionForm',
      setSessionStep: 'invoice-parameter/setSessionStep',
      updateFormConfig: 'invoice-parameter/updateConfig',
      setIsRHProtegido: 'user-info/setIsRHProtegido',
      resetForm: 'invoice-parameter/resetForm',
      setAppOrigin: 'user-info/setAppOrigin',
      loading: 'invoice-parameter/loading',
    }),
    async startSelectionStepValidation() {
      if (!this.$refs.LevelSelectionStep.validate()) return;
      const validated = await this.validateConfigsInSelectionStep();
      if (validated) {
        this.goToAdvanceRuleDetail();
      }
    },
    startCancelation() {
      this.setShowCancelConfirmModal(true);
    },
    confirmUpdateStatusToInactive(confirmation) {
      if (confirmation) {
        this.updateFormConfig(this.configInValidation);
        this.setShowRuleStatusInactiveUpdatedModal(true);
      } else {
        this.updateFormConfig({
          tempId: this.configInValidation.tempId,
          config: {
            active: !this.configInValidation.config.active,
          }
        });
      }

      this.setShowRuleStatusInactiveModal({show: false});
    },
    confirmUpdateStatusToActive(confirmation) {
      if (confirmation) {
        this.updateFormConfig(this.configInValidation);
        this.setShowRuleStatusActiveUpdatedModal(true);
      } else {
        this.updateFormConfig({
          tempId: this.configInValidation.tempId,
          config: {
            active: !this.configInValidation.config.active,
          }
        });
      }

      this.setShowRuleStatusActiveModal({show: false});
    },
    confirmUnlink(confirmation) {
      if (confirmation) {
        this.updateFormConfig(this.configInValidation);
        this.setShowRuleUnlinkSuccessModal(true);
      } else {
        this.updateFormConfig({
          tempId: this.configInValidation.tempId,
          config: {
            unlink: !this.configInValidation.config.unlink,
          }
        });
      }

      this.setShowRuleUnlinkModal({show: false});
    },
    confirmLink(confirmation) {
      if (confirmation) {
        this.updateFormConfig(this.configInValidation);
        this.setShowRuleLinkSuccessModal(true);
      } else {
        this.updateFormConfig({
          tempId: this.configInValidation.tempId,
          config: {
            unlink: !this.configInValidation.config.unlink,
          }
        });
      }

      this.setShowRuleLinkModal({show: false});
    },
    cancel(confirmation) {
      if (!confirmation) return;
      this.refreshForm();
    },
    refreshForm() {
      this.goBackToOperationalRoutines();
      this.resetForm();
    },
    async saveConfig() {
      if (!this.validFormRules()) return;
      const result = await this.createNewConfigs();
      if (result) {
        this.setShowRuleUpdatedSuccessfullyModal(true);
      }
    },
    async updateConfig() {
      if (!this.validFormRules()) return;
      const result = await this.updateRuleConfigurations();
      if (result) {
        this.setShowRuleUpdatedSuccessfullyModal(true);
      }
    },
    async copyConfig() {
      if (!this.validFormRules()) return;
      const result = await this.copyFormConfig();
      if (result) {
        this.setShowRuleUpdatedSuccessfullyModal(true);
      }
    },
    validFormRules() {
      if (!this.$refs.InvoiceRuleDetail.validate()) return false;
      if (!this.newConfigInactiveRule()) return false;

      return true;
    },
    goBackToOperationalRoutines() {
      this.$router.push('operational-routines');
    },
    handlePageRefresh() {
      this.invoiceParameterSessions.forEach((session) => {
        sessionStorage.setItem(session.key, JSON.stringify(session.value));
      });
    },
    setSessionPage() {
      this.invoiceParameterSessions.forEach((session) => {
        if (sessionStorage.getItem(session.key)) {
          const data = JSON.parse(sessionStorage.getItem(session.key));
          session.action(data);
          sessionStorage.removeItem(session.key);
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      showRuleStatusInactiveUpdatedModal: 'invoice-parameter/showRuleStatusInactiveUpdatedModal',
      showRuleUpdatedSuccessfullyModal: 'invoice-parameter/showRuleUpdatedSuccessfullyModal',
      showRuleStatusActiveUpdatedModal: 'invoice-parameter/showRuleStatusActiveUpdatedModal',
      showConfirmAlterationRuleModal: 'invoice-parameter/showConfirmAlterationRuleModal',
      showConflictingRuleFoundModal: 'invoice-parameter/showConflictingRuleFoundModal',
      showRuleStatusInactiveModal: 'invoice-parameter/showRuleStatusInactiveModal',
      showCreateRuleInactiveModal: 'invoice-parameter/showCreateRuleInactiveModal',
      showRuleUnlinkSuccessModal: 'invoice-parameter/showRuleUnlinkSuccessModal',
      showRuleStatusActiveModal: 'invoice-parameter/showRuleStatusActiveModal',
      showRuleLinkSuccessModal: 'invoice-parameter/showRuleLinkSuccessModal',
      showCancelConfirmModal: 'invoice-parameter/showCancelConfirmModal',
      showRelatedRulesModal: 'invoice-parameter/showRelatedRulesModal',
      showSnackbarCustomize: 'invoice-parameter/showSnackbarCustomize',
      showRuleCreatedModal: 'invoice-parameter/showRuleCreatedModal',
      showConfirmInfoModal: 'invoice-parameter/showConfirmInfoModal',
      showRuleUnlinkModal: 'invoice-parameter/showRuleUnlinkModal',
      configInValidation: 'invoice-parameter/configInValidation',
      showRuleLinkModal: 'invoice-parameter/showRuleLinkModal',
      isUpdatingConfig: 'invoice-parameter/isUpdatingConfig',
      isCreatingConfig: 'invoice-parameter/isCreatingConfig',
      isCopyingConfig: 'invoice-parameter/isCopyingConfig',
      step: 'invoice-parameter/invoiceParameterStep',
      loadingForm: 'invoice-parameter/loadingForm',
      currentForm: 'invoice-parameter/currentForm',
      appOrigin: 'user-info/appOrigin',
      form: 'invoice-parameter/form',
    }),
    invoiceParameterSessions() {
      return [
        { key: 'invoice-parameter-is-creating', value: this.isCreatingConfig, action: this.setSessionIsCreating },
        { key: 'invoice-parameter-is-updating', value: this.isUpdatingConfig, action: this.setSessionIsUpdating },
        { key: 'invoice-parameter-current-form', value: this.currentForm, action: this.setSessionCurrentForm },
        { key: 'invoice-parameter-is-copying', value: this.isCopyingConfig, action: this.setSessionIsCopying },
        { key: 'invoice-parameter-form', value: this.form, action: this.setSessionForm },
        { key: 'invoice-parameter-step', value: this.step, action: this.setSessionStep },
      ];
    }
  },
  async created() {
    const isRHProtegido = this.$route.query.isRHProtegido
      ? this.stringToBoolean(this.$route.query.isRHProtegido.toString())
      : this.appOrigin && this.appOrigin !== 'BACKOFFICE';

    this.setIsRHProtegido(isRHProtegido);
    this.setAppOrigin(isRHProtegido ? 'PROTECTED_HR' : 'BACKOFFICE');

    this.loading(true);
    await this.getRuleData();
    this.loading(false);
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.handlePageRefresh);
    this.setSessionPage();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handlePageRefresh);
  },
}
</script>

<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>